<div id="add-task">
    <h2 class="m-b-5" mat-dialog-title>Agregar Tarea</h2>
    <div mat-dialog-content>

        <app-task-management [LeaveId]="leaveId" [EmployeeId]="employeeId" [task-operation]="taskCreationOperation">
        </app-task-management>

        <mat-progress-bar class="m-t-15" mode="indeterminate" *ngIf="isSaving"></mat-progress-bar>

        <div class="text-a-r p-t-5 p-t-15">
            <button mat-raised-button color="accent" (click)="saveTask()" class="m-r-15">Guardar</button>
            <button mat-raised-button (click)="cancel()" color="warn">Cancelar</button>
        </div>

    </div>
</div>